import styled, { css } from 'styled-components';

export const StyledFooterContent = styled.div<{ isRedesignEnabled: boolean }>`
  ${({ theme, isRedesignEnabled }) => css`
    color: ${theme.color.text.dark};

    ${isRedesignEnabled &&
    css`
      color: ${theme.color.base.dark};

      a {
        color: ${theme.color.base.dark};

        &:hover, &:active {
          color: ${theme.color.primary.light};
        }
      `}
  `}
`;
